import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
declare const ymaps: any;

@Component({
  selector: 'app-yandex-map',
  templateUrl: './yandex-map.component.html',
  styleUrls: ['./yandex-map.component.css'],
})
export class YandexMapComponent implements OnInit {
  map: any;
  @Input() latitude: number;
  @Input() longitude: number;

  @ViewChild('yamaps')
  el!: ElementRef;

  constructor() {}

  ngOnInit(): void {
    ymaps.ready().done(() => this.mapGen(this.latitude, this.longitude));
  }

  private createMap(): void {
    this.map = new ymaps.Map('map', {
      center: [this.latitude, this.longitude],
      zoom: 14,
    });

    const placeMark = new ymaps.Placemark([this.latitude, this.longitude]);
    this.map.geoObjects.add(placeMark);
  }

  mapGen(lat, long) {
    ymaps.ready(function () {
      var myMap = new ymaps.Map(
          'map',
          {
            center: [lat, long],
            zoom: 9,
          },
          {
            searchControlProvider: 'yandex#search',
          }
        ),
        // Creating a content layout.
        MyIconContentLayout = ymaps.templateLayoutFactory.createClass(
          '<div style="color: #FFFFFF; font-weight: bold;">$[properties.iconContent]</div>'
        ),
        myPlacemarkWithContent = new ymaps.Placemark(
          [lat, long],
          {
            hintContent: '',
            balloonContent: '',
            iconContent: '',
          },
          {
            /**
             * Options.
             * You must specify this type of layout.
             */
            iconLayout: 'default#imageWithContent',
            // Custom image for the placemark icon.
            iconImageHref: '/assets/images/sprite.png',
            // The size of the placemark.
            iconImageSize: [48, 48],
            /**
             * The offset of the upper left corner of the icon relative
             * to its "tail" (the anchor point).
             */
            iconImageOffset: [-24, -24],
            // Offset of the layer with content relative to the layer with the image.
            iconContentOffset: [15, 15],
            // Content layout.
            iconContentLayout: MyIconContentLayout,
          }
        );

      myMap.geoObjects.add(myPlacemarkWithContent);
    });
  }
}
